/**
 * 埋点数据
 * */ 
import { addEventLog } from "@/apis/apis.js";

export const eventLog = (type)=>{
    const currentRoute = getCurrentRoute();
    // 只能通过 navigator.hardwareConcurrency 获取逻辑核心数
			const logicalProcessors = navigator.hardwareConcurrency;
			console.log('逻辑核心数:', logicalProcessors);

			// 获取设备唯一标识 (UUID)
			let deviceId = localStorage.getItem('deviceId');
			if (!deviceId) {
				deviceId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
					var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
					return v.toString(16);
				});
				localStorage.setItem('deviceId', deviceId);
			}
			
			// 恢复埋点逻辑
			addEventLog({
				deviceId,
        eventCode: type,
        pageUrl: currentRoute.name || '',
			})
}

function getCurrentRoute() {
    if (window.__MULTI_PAGE_ROUTE__) {
        return window.__MULTI_PAGE_ROUTE__;
    }

    try {
        const routerModule = require("@/router");
        return (routerModule.default && routerModule.default.currentRoute) || {};
    } catch (error) {
        return {};
    }
}
